/* Compteur panier WarGrounds.

   Probleme corrige : dans wg-theme.js, la mise a jour du badge [data-wg-cart-count] est
   imbriquee dans updateGauge(), qui sort immediatement quand [data-wg-shipgauge] est absent
   de la page. Resultat : le badge restait fige a sa valeur du rendu serveur (souvent 0)
   apres chaque ajout au panier.

   Ce script observe les appels reseau vers /cart/* et resynchronise le badge depuis /cart.js.
   Il n'altere pas le comportement de fetch : il se contente d'ecouter la promesse. */
(function () {
  var pending = null;

  /* Libelle accessible du badge, traduit. Les chaines sont rendues par layout/theme.liquid
     dans la langue du marche courant ; repli en francais si le dictionnaire manque. */
  function label(count) {
    var dict = window.wgI18n || {};
    var key = count > 1 ? 'cart_items_other' : 'cart_items_one';
    var fallback = count > 1 ? '%total% articles' : '%total% article';
    var s = dict[key];
    if (typeof s !== 'string' || s === '') s = fallback;
    return s.split('%total%').join(count);
  }

  function paint(count) {
    document.querySelectorAll('[data-wg-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.setAttribute('aria-label', label(count));
      el.classList.toggle('is-empty', count === 0);
    });
  }

  function refresh() {
    if (pending) return pending;
    pending = fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { paint(cart.item_count); })
      .catch(function () { /* silencieux : le badge garde sa valeur precedente */ })
      .then(function () { pending = null; });
    return pending;
  }

  function urlOf(input) {
    if (typeof input === 'string') return input;
    if (input && typeof input.url === 'string') return input.url;
    try { return String(input); } catch (e) { return ''; }
  }

  if (window.fetch) {
    var native = window.fetch;
    window.fetch = function () {
      var url = urlOf(arguments[0]);
      var promise = native.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)/.test(url)) {
        promise.then(function () { setTimeout(refresh, 80); }, function () {});
      }
      return promise;
    };
  }

  /* Retour arriere depuis le checkout : la page peut venir du bfcache, donc resynchroniser. */
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
})();
